import { useViewList } from "@/context/ViewListContext";
import { NavigateOptions } from "@vixi/router";
import { FC, useMemo } from "react";
import { useForm } from "react-hook-form";
import { UploadEbookFormValues } from "../ebook/UploadEbookStep";
import ViewList, { ViewListItem } from "@/components/layout/ViewList";
import BookInfoForm from "../BookInfoForm";
import { LinkedInContentForm } from "./LinkedInContentForm";
import { useGoBack, useCourseEditorContext } from "@vixi/ui";

interface UploadEbookProps {}

export const AddContentStep: FC<UploadEbookProps> = () => {
  const viewList = useViewList();

  // Go back
  const goBack = useMemo(
    () =>
      viewList.activeStep === 0
        ? ({
            to: "..",
            replace: true,
          } as NavigateOptions)
        : viewList.prevStep,
    [viewList.activeStep],
  );
  useGoBack(goBack);

  // Store
  const { setValue } = useCourseEditorContext();

  // Form
  const {
    control,
    watch,
    setValue: setFormValue,
    getValues: getFormValue,
  } = useForm<UploadEbookFormValues>();
  const showNextBtn = watch("ebook")?.length > 0;

  // Sync form values with store
  const syncFormValues = (values: UploadEbookFormValues) => {
    const options = { mustExist: false };

    setValue(["ebookAbout"], values.bookInfo.about, options);
    setValue(["targetAudience"], values.bookInfo.audience, options);
    setValue(["conversationTone"], values.bookInfo.tone, options);
  };

  return (
    <ViewList {...viewList}>
      {/* Pick pdf to upload */}
      <ViewListItem>
        <LinkedInContentForm />
      </ViewListItem>

      {/* Book Info Form */}
      <ViewListItem >
        <BookInfoForm
          onSubmit={(values) => {
            setFormValue("bookInfo", values);
            syncFormValues(getFormValue());
          }}
        />
      </ViewListItem>
    </ViewList>
  );
};
